import script from "./biz-status-select.vue?vue&type=script&lang=tsx&setup=true"
export * from "./biz-status-select.vue?vue&type=script&lang=tsx&setup=true"

import "./biz-status-select.vue?vue&type=style&index=0&id=e7dc3b7e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7dc3b7e"]])

export default __exports__